import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Form, Input } from 'antd';
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import { AiOutlineUser } from "react-icons/ai";

import axios from "../../../services/axios"
import { loginSuccess } from "../../../store/actions/auth";
import { setMessage } from "../../../store/actions/message";
import { useAuthenticate } from "../../../services/hooks/useAuthenticate";

import ContainerWithIconHeader from "../../UI/ContainerWithIconHeader/ContainerWithIconHeader";
import SubmitButton from "../../UI/SubmitButton/SubmitButton";
import { getPersonalInfoData } from "../../../store/actions";

const AdminAuth = (props) => {
    const [studentCardNumber, setStudentCardNumber] = useState('')
    const [loading, setLoading] = useState(false)
    const [ifError, setIfError] = useState(false)

    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const hasNotConfirmedContact = useSelector(state => state.auth.hasNotConfirmedContact)

    useAuthenticate(props.history)

    const handleSubmit = () => {
        setLoading(true)
        setIfError(false)
        axios.post(`api/v1/auth/login-as-student`, {
            studentCardNumber: studentCardNumber
        }).then((response) => {
            setLoading(false)
            dispatch(getPersonalInfoData())
            dispatch(loginSuccess(response.data, true))
        }).catch((error) => {
            setLoading(false)
            if (error.response.status) setIfError(true)
            else dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
        })
    };

    return (
        <ContainerWithIconHeader
            icon={<IoShieldCheckmarkSharp size={30} />}
            title="Администратор">
            <Form
                name="admin_login"
                scrollToFirstError={true}
                onFinish={handleSubmit}
                className="AdminAuth_formContainer">
                <Form.Item
                    name="login"
                    hasFeedback={true}
                    rules={[
                        { required: true, message: 'Данное поле является обязательным!' },
                        {
                            pattern: /^((([ad]|\d)([ad]|\d)(\d){6}$)|((\d){7}$))$/g,
                            message: 'Некорректный формат номера студенческого билета'
                        }
                    ]}>
                    <Input
                        prefix={<AiOutlineUser />}
                        placeholder="Студенческий билет"
                        value={studentCardNumber}
                        onChange={(e) => setStudentCardNumber(e.target.value.trim())} />
                </Form.Item>
                <Form.Item>
                    <SubmitButton
                        type="submit"
                        text="Отправить"
                        block
                        loading={loading}
                    />
                </Form.Item>

                {(ifError) && <Form.Item>
                    <Alert
                        message="Ошибка!"
                        description="Не удалось найти аккаунт"
                        type="error"
                        showIcon
                    />
                </Form.Item>}
            </Form>
        </ContainerWithIconHeader>
    );
}

export default AdminAuth;
